import React, { useMemo } from 'react';

import NoItemsInList from '../../../components/NoItemsInList';
import Scrollable from '../../../components/Scrollable';
import Loader from '../../../components/Loader';
import { useData, useFilter } from './context';
import { ActivityTableRow, ActivityTable, LinkStyled, ContentBoard } from '../styledComponents';

const COLS = 5;

const formatMs = (ms) => {
  if (ms == null) return '–';
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${ms}ms`;
};

export default function List() {
  const { isLoading, stats } = useData();
  const filter = useFilter();
  const partners = stats?.byPartner || [];

  const params = useMemo(() => {
    const params = new URLSearchParams();
    params.set('period', filter.period);
    if (filter.dealers?.length) {
      filter.dealers.forEach((d) => params.append('dealers', d.hmsId));
    }
    if (filter.channel?.value) params.set('channel', filter.channel?.value);
    if (filter.status?.value) params.set('status', filter.status?.value);
    if (filter.vin) params.set('vin', filter.vin);

    return params.toString();
    // eslint-disable-next-line
  }, [filter]);

  return (
    <ContentBoard heightCorrection={224}>
      {partners.length > 0 ? (
        <ActivityTable>
          <ActivityTableRow head columns={COLS}>
            <div>Partner</div>
            <div>Total requests</div>
            <div>Verified</div>
            <div>Not found</div>
            <div>Avg response</div>
          </ActivityTableRow>
          <Scrollable>
            {partners.map((row, index) => (
              <ActivityTableRow key={`partner-row--${index}`} columns={COLS}>
                <div style={{ fontWeight: 600 }}>
                  {row.partnerId ? (
                    <LinkStyled
                      to={`/partner-stats/${row.partnerId}?${params}`}
                      style={{ color: '#283890', textDecoration: 'none' }}
                    >
                      {row.partnerName}
                    </LinkStyled>
                  ) : (
                    <span style={{ color: '#9595a8' }}>Unknown</span>
                  )}
                </div>
                <div>{row.total ?? '–'}</div>
                <div>
                  {row.verified ?? '–'}
                  {row.total > 0 && (
                    <span style={{ fontSize: 11, color: '#677b8b', marginLeft: 5 }}>
                      {row.verifiedRate}%
                    </span>
                  )}
                </div>
                <div>
                  {row.notFound ?? '–'}
                  {row.total > 0 && (
                    <span style={{ fontSize: 11, color: '#677b8b', marginLeft: 5 }}>
                      {row.notFoundRate}%
                    </span>
                  )}
                </div>
                <div>{formatMs(row.avgResponseTimeMs)}</div>
              </ActivityTableRow>
            ))}
          </Scrollable>
        </ActivityTable>
      ) : (
        <NoItemsInList>{!isLoading ? 'No partner stats to show' : ''}</NoItemsInList>
      )}
      <Loader isLoading={isLoading} firstLoad={true} />
    </ContentBoard>
  );
}
